import axios from "axios";
import { API_BASE } from "@config/env";

const BASE = API_BASE + "connectiq/";

const call = (route, data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => {
    if (v != null) fd.append(k, v);
  });
  return axios.post(BASE + route, fd).catch(() => null);
};

export const connectiqGetProfileSessions = (u, r) =>
  call("get_profile_sessions", { user_slug: u, resource_slug: r });
export const connectiqGetProfileHistory = (u, sid) =>
  call("get_profile_history", { user_slug: u, session_id: sid });
export const connectiqCreateProfileSession = (u, r, name) =>
  call("create_profile_session", {
    user_slug: u,
    resource_slug: r,
    candidate_name: name,
  });
export const connectiqDeleteSession = (u, sid) =>
  call("delete_session", { user_slug: u, session_id: sid });
export const connectiqProfileChat = (
  u,
  msg,
  profile,
  r,
  name,
  sid,
  qtype = "general",
) =>
  call("profile_chat", {
    user_slug: u,
    message: msg,
    profile_text: profile,
    resource_slug: r,
    candidate_name: name,
    session_id: sid || "",
    query_type: qtype,
  });
